import { render, staticRenderFns } from "./wheel.vue?vue&type=template&id=4b918c89&scoped=true"
import script from "./wheel.vue?vue&type=script&lang=js"
export * from "./wheel.vue?vue&type=script&lang=js"
import style0 from "./wheel.vue?vue&type=style&index=0&id=4b918c89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b918c89",
  null
  
)

export default component.exports